module.exports = __webpack_public_path__ + "img/intro-claimed.61f73268.png";